module.exports = __webpack_public_path__ + "static/media/visible_places_ic.21ac1786.svg";